import React from "react";
import "./not-found.css";

const NotFound = () => {
  return (
    <>
      <div>NotFound</div>
    </>
  );
};

export default NotFound;
